export default __webpack_public_path__ + "locales/uk-UA/Payments.json?hash=c93b3e1f6a45172cfc21e41d335505a3";